<template>
  <div id="app">
    <!-- This is where your routed components will be displayed -->
    <router-view />
  </div>
</template>

<script setup>
// App.vue should be minimal - just the router-view
// All your content should be in individual page components
</script>

<style>
/* Global styles can go here */
body {
  margin: 0;
  padding: 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}
</style>